export interface ProyectoRelacionado{
    iddecinvproductorelacionproyecto: number,
    iddecinvproyectoprodtermin: number,
    iddecinvproyecto: number,
	tituloProyecto:string
}

export function getVoidProyectoRelacionado():ProyectoRelacionado{
    return {
        iddecinvproductorelacionproyecto: 0,
        iddecinvproyectoprodtermin: 0,
        iddecinvproyecto: 0,
	    tituloProyecto:""
    }
}

export function setProyectoRelacionado(row: any):ProyectoRelacionado{
    return {
        iddecinvproductorelacionproyecto: row.iddecinvproductorelacionproyecto ??0,
        iddecinvproyectoprodtermin: row.iddecinvproyectoprodtermin ??0,
        iddecinvproyecto: row.iddecinvproyecto ??0,
	    tituloProyecto: row.tituloProyecto ??""
    }
}

export function setListProyectoRelacionado(data: Array<any>): Array<ProyectoRelacionado>{
    let list: Array<ProyectoRelacionado> = [];
    data.forEach((item) => {
        const proy: ProyectoRelacionado = setProyectoRelacionado(item)
        list.push(proy);
    });
    return list;
}